import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { courses as localCourses } from "../data/courses";
import { API_URL } from "../apiConfig";



const Services = () => {
  const navigate = useNavigate();

  const [courses, setCourses] = useState(localCourses.map(c => ({
    id: c.id,
    img: c.bannerImage,
    title: c.title,
    desc: c.overview,
    isApi: false
  })));

  useEffect(() => {
    console.log('Services: Fetching from:', API_URL);
    fetch(API_URL)

      .then(res => res.json())
      .then(data => {
        console.log('Services API Data:', data);
        const apiCourses = Array.isArray(data) ? data : (data.courses || []);
        if (apiCourses.length > 0) {
          const mappedApi = apiCourses.map((c, index) => ({
            id: `api-${index}`,
            img: `/course${(index % 3) + 1}.avif`,
            title: c.course_title,
            desc: `${c.course_category} - ${c.duration} ${c.duration_unit}. Fee: $${c.course_fee}`,
            isApi: true
          }));
          
          const mappedLocal = localCourses.map(c => ({
            id: c.id,
            img: c.bannerImage,
            title: c.title,
            desc: c.overview,
            isApi: false
          }));

          setCourses([...mappedLocal, ...mappedApi]);
        }
      })
      .catch(err => console.error('Services Fetch error:', err));
  }, []);

  const services = courses;


  return (
    <section className="py-20 bg-[#f9fffb]" id="services">
      <div className="text-center mb-12">
        <h2 className="text-[#121714] text-[32px] font-bold tracking-tight">
          Our Courses
        </h2>
        <p className="text-[#555] text-lg max-w-2xl mx-auto mt-3">
          Empowering workplaces with globally recognized safety and compliance training.
        </p>
      </div>

      <div className="flex flex-col gap-20">
        {services.map((service, i) => (
          <div
            key={service.id}
            onClick={() => navigate(`/course-details/${service.id}`)}
            className={`cursor-pointer flex flex-col md:flex-row ${
              i % 2 !== 0 ? "md:flex-row-reverse" : ""
            } items-center gap-10 px-6 md:px-20 transition-transform duration-500 hover:scale-105`}
          >
            <div
              className="w-full md:w-1/2 aspect-video rounded-2xl bg-center bg-cover shadow-lg"
              style={{ backgroundImage: `url(${service.img})` }}
            ></div>

            <div className="w-full md:w-1/2 text-center md:text-left">
              <h3 className="text-2xl font-semibold text-[#2ea36b] mb-3">
                {service.title}
              </h3>
              <p className="text-[#121714] text-base leading-relaxed mb-4">
                {service.desc}
              </p>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(service.isApi ? '/api-courses' : `/course-details/${service.id}`);
                }}
                className="bg-[#0b9949] text-white px-6 py-2 rounded-full hover:bg-[#097c3c] transition-all"
              >
                Read More
              </button>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
